<template>
    <v-dialog v-model="showDialog" max-width="800" :fullscreen="$vuetify.breakpoint.smAndDown" :persistent="editing || loading" scrollable @click:outside="editing ? $store.dispatch('showError', 'You are editing a note, please click cancel or hit submit') : null">
        <template v-slot:activator="{on}">
            <slot name="activator" :on="on"></slot>
        </template>
        <v-card :loading="loading" :disable="loading">
            <v-card-title>Add Note to: {{customer.name}}</v-card-title>
            <v-card-actions v-if="notes && notes.some( v=> v.is_important)" class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-alert type="error" dense>There are important notes in here. Please check them out.</v-alert>
                <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-text>
                <v-timeline >
                    <v-timeline-item
                            v-for="(note, index) in notes"
                            :key="index"
                            :right="$store.getters.id === note.user_uid"
                            :left="$store.getters.id !== note.user_uid"
                            :color="$store.getters.id === note.user_uid ? 'primary' : 'info'"
                    >
                        <template v-slot:opposite>
                            {{fancyHumanTime(note.date)}}
                        </template>
                        <v-card
                                dark
                                :color="$store.getters.id === note.user_uid ? ((editing && editedNoteIndex === index) ? 'orange darken-2' : 'primary') : 'info'"
                        >
                            <v-card-actions class="title pa-1">
                                <span class="title">{{$store.getters.id === note.user_uid ? 'Me' : note.name}}</span>
                                <span class="subtitle-1 ml-1">{{note.edited ? ' (edited)' : ''}}</span>
                                <v-spacer></v-spacer>
                                <v-btn  v-if="$store.getters.id === note.user_uid" @click="editNote(note, index)" icon text><v-icon>edit</v-icon></v-btn>
                            </v-card-actions>
                            <v-card-text class="white text--primary">
                                <p>{{note.note}}</p>
                            </v-card-text>
                            <v-card-actions v-if="note.is_important" class="pa-0">
                                <v-alert  class="ma-0 subtitle" type="error" dense>This note is important! Please read!</v-alert>
                            </v-card-actions>
                        </v-card>
                    </v-timeline-item>
                </v-timeline>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions v-if="editing || isImportant" class="pt-0">
                <v-alert v-if="editing" type="info" color="orange darken-2" class="pa-1 ma-0">You are editing a note! Click 'cancel' to reset.</v-alert>
                <v-spacer></v-spacer>
                <v-alert v-if="isImportant" type="error" class="pa-1 ma-0">You are making a highlighted note!</v-alert>
            </v-card-actions>
            <v-card-actions class="pa-0">
                <v-text-field
                        v-model="note"
                        label="Note"
                        @keyup.enter="save()"
                        solo
                        persistant-hint
                        :hint="editing ? 'Edit note!' : 'Write a note!'"
                        outlined
                >
                </v-text-field>
            </v-card-actions>
            <v-card-actions v-if="editing" class="pt-0">
                <v-btn @click="cancelEditing()" text>cancel</v-btn>
                <v-spacer></v-spacer>
                <v-checkbox v-model="isImportant" label="Mark as important"></v-checkbox>
                <v-spacer></v-spacer>
                <v-btn @click="saveEditedNote()" color="orange darken-2">Update</v-btn>
            </v-card-actions>
            <v-card-actions v-else class="pt-0">
                <v-btn @click="showDialog = false" text>close</v-btn>
                <v-spacer></v-spacer>
                <v-checkbox v-model="isImportant" label="Mark as important"></v-checkbox>
                <v-spacer></v-spacer>
                <v-btn @click="save()" color="success">submit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import moment from 'moment';
    import firebase from 'firebase/app';
    import 'firebase/firestore';
    export default {
        name: "AddNoteToCustomer",
        props:{
            customer:{
                required: true,
                type: Object,
            },
        },
        data: () => ({
            showDialog: false,
            notes: null,
            note: null,
            editedNoteIndex: null,
            editing: false,
            isImportant: false,
            loading: false,
        }),
        watch:{
            customer(v){
                if(v.notes){
                    this.sortByDate();
                }
            }
        },
        mounted(){
            if(this.customer.notes){
                this.sortByDate();
            }
        },
        methods:{
            sortByDate(){
                this.notes = [...this.customer.notes];
            },
            fancyHumanTime(date){
                return moment(date).fromNow();
            },
            editNote(note, index){
                this.editing = true;
                this.editedNoteIndex = index;
                this.isImportant = note.is_important
                this.note = note.note;
            },
            saveEditedNote(){
                if(this.notes[this.editedNoteIndex].note === this.note && this.notes[this.editedNoteIndex].is_important === this.isImportant){
                    this.$store.dispatch("showError", "Nothing changed in the note, so nothing extra was stored.");
                    this.cancelEditing();
                    return;
                }
                this.loading =true;
                this.notes[this.editedNoteIndex].note = this.note;
                this.notes[this.editedNoteIndex].is_important = this.isImportant;
                this.notes[this.editedNoteIndex].edited = true;
                firebase.firestore()
                    .collection("scheduled")
                    .doc(this.customer.id)
                    .update({
                        notes: this.notes,
                    }).then(() => {
                        this.$store.dispatch("showSuccess", "Updated note!")
                        this.loading =false;
                        this.cancelEditing();
                })
            },
            cancelEditing(){
                this.editing = false;
                this.editedNoteIndex = null;
                this.isImportant = false;
                this.note = null;
            },
            save(){
                this.loading =true;
                firebase.firestore().collection('scheduled').doc(this.customer.id)
                    .update({
                        notes: firebase.firestore.FieldValue.arrayUnion({
                            note: this.note,
                            date: moment().toISOString(),
                            name: this.$store.getters.name,
                            user_uid: this.$store.getters.id,
                            is_important: this.isImportant
                        }),
                        updated_at: moment().toISOString()
                    }).then(() => {
                        this.cancelEditing();
                        this.$store.dispatch("showSuccess", "Sent Note!");
                        this.loading =false;
                }).catch(() => {
                    this.$store.dispatch("showError", "Something went wrong while sending your note");
                    this.loading =false;
                })
            }
        }
    }
</script>

<style scoped>

</style>
